import { mergeQueryParams } from '@/utils/merge-query-params';
import { Params } from '@/utils/types';
import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useDebouncedCallback } from 'use-debounce';

export default function useTasksFilters() {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const setDebouncedQueryParam = useDebouncedCallback(mgId => {
		if (!mgId) {
			const queryString = mergeQueryParams(searchParams, {
				[Params.mgId]: undefined,
				[Params.page]: 1
			});

			navigate(`?${queryString}`);
			return;
		}
		const queryString = mergeQueryParams(searchParams, {
			[Params.mgId]: mgId,
			[Params.page]: 1
		});

		navigate(`?${queryString.toString()}`);
	}, 500);

	const handleMgIdChange = useCallback(
		(mgId: string) => {
			setDebouncedQueryParam(mgId);
		},
		[setDebouncedQueryParam]
	);

	const handleTaskTypeChange = useCallback(
		(type: string) => {
			if (!type || type === 'All') {
				const queryString = mergeQueryParams(searchParams, {
					[Params.type]: undefined,
					[Params.page]: 1
				});

				navigate(`?${queryString}`);
				return;
			}
			const queryString = mergeQueryParams(searchParams, {
				[Params.type]: type,
				[Params.page]: 1
			});

			navigate(`?${queryString.toString()}`);
		},
		[navigate, searchParams]
	);

	const handleTaskStatusChange = useCallback(
		(status: string) => {
			if (!status || status === 'All') {
				const queryString = mergeQueryParams(searchParams, {
					[Params.status]: undefined,
					[Params.page]: 1
				});

				navigate(`?${queryString}`);
				return;
			}
			const queryString = mergeQueryParams(searchParams, {
				[Params.status]: status,
				[Params.page]: 1
			});

			navigate(`?${queryString.toString()}`);
		},
		[navigate, searchParams]
	);

	return { handleMgIdChange, handleTaskTypeChange, handleTaskStatusChange };
}
